import { Badge } from '@amzn/awsui-components-react';

import { CATALOGICAL_EDIT_ITEM_URL } from '../../configuration/config';
import { getValidationBadgeColor, getValidationBadgeLabel } from '../../common/utils/table-utils';

/**
 * Renders a validation verdict as a colored badge.
 */
export const getValidationBadge = (verdict?: string): JSX.Element => {
  return <Badge color={getValidationBadgeColor(verdict)}>{getValidationBadgeLabel(verdict)}</Badge>;
};

/**
 * Builds the Catalogical edit-item URL for a given taxonomy ID.
 */
export const buildCatalogicalUrl = (taxonomyId: string): string => {
  return CATALOGICAL_EDIT_ITEM_URL.replace('{ITEM_ID}', taxonomyId);
};
